
import Vue from "vue";

export default Vue.extend({
  name: "AiJobDescriptionModal",
  data() {
    return {
      dialog: true
    };
  },
  props: {
    job_description: {
      type: String,
      required: true
    },
    job_title: {
      type: String,
      required: true
    }
  }
});
